import React from 'react';

export const About = () => (
  <div className="About">
    <h2>Covid-19 Tracking Data</h2>
    <div className="About-text">
      Coronavirus disease (COVID-19) is an infectious disease caused by the SARS-CoV-2 virus.
      Most people who fall sick with COVID-19 will experience mild to moderate symptoms and
      recover without special treatment. However, some will become seriously ill and require
      medical attention.The virus can spread from an infected person’s mouth or nose in small
      liquid particles when they cough, sneeze, speak, sing or breathe. These particles range
      from larger respiratory droplets to smaller aerosols.
    </div>
  </div>
);
export default About;
